import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { FirewallRuleCreatePage } from '@/features/admin/firewall/firewall-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvelle règle de pare-feu (porting README #21). */
export const Route = createFileRoute('/$tenant/firewall/new')({ component: NewFirewallRuleRoute });

function NewFirewallRuleRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="firewall"
      crumbs={[{ label: t('nav.items.firewall') }, { label: t('admin.firewall.newTitle') }]}
    >
      <FirewallRuleCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
